/**
 * Wishlist Manager
 * Handles adding, removing, button active state, wishlist page render, count, and toast.
 */
window.wishlist = (function (cache) {
  let am = 0;
  const on = { wished: [], unwish: [] };

  let wishes = {};

  try {
    wishes = JSON.parse(typeof cache === 'string' && cache ? cache : '{}') || {};
  } catch (error) {
    wishes = {};
  }

  const getWishButtons = (el = '.wish-button') => document.body.querySelectorAll(el);

  const getProductDataFromNode = (node) => {
    return {
      id: node.dataset.id || '',
      productName: node.dataset.productName || 'Unnamed Product',
      price: node.dataset.price || 'N/A',
      image: node.dataset.image || '',
      handle: node.dataset.handle || ''
    };
  };

  const showToast = (message, type = 'info', duration = 3000) => {
    let container = document.getElementById('wishlist-toast-container');

    if (!container) {
      container = document.createElement('div');
      container.id = 'wishlist-toast-container';
      document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = `wishlist-toast ${type}`;
    toast.textContent = message;
    container.appendChild(toast);

    setTimeout(() => {
      toast.classList.add('show');
    }, 10);

    setTimeout(() => {
      toast.classList.remove('show');
      toast.addEventListener('transitionend', () => toast.remove(), { once: true });
    }, duration);
  };

  const updateWishlistCount = (selector = '[data-wishes]') => {
    am = Object.keys(wishes).length;
    document.querySelectorAll(selector).forEach((count) => {
      count.innerText = am;
    });
  };

  const updateButtonState = (id, node = null) => {
    if (!id) return;

    const updateNode = (btn) => {
      const icon = btn.querySelector('.gc-wishlist-icon');
      const text = btn.querySelector('.gc-wishlist-text');

      if (id in wishes) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');

        if (icon) icon.innerHTML = '♥';
        if (text && text.dataset.addedText) text.innerHTML = text.dataset.addedText;
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');

        if (icon) icon.innerHTML = '♡';
        if (text && text.dataset.defaultText) text.innerHTML = text.dataset.defaultText;
      }
    };

    if (node && node.classList && node.classList.contains('wish-button')) {
      updateNode(node);
      return;
    }

    getWishButtons(`[data-id="${id}"]`).forEach(updateNode);
  };

  const updateAllButtons = () => {
    getWishButtons().forEach((btn) => {
      if (btn.dataset.id) {
        updateButtonState(btn.dataset.id, btn);
      }
    });
  };

  const renderWishlistPage = () => {
    const wishlistContainer = document.getElementById('wishlist-items');
    const emptyMessage = document.querySelector('.empty-wishlist-message');

    if (!wishlistContainer) return;

    wishlistContainer.innerHTML = '';

    const wishListItems = Object.values(wishes);

    if (wishListItems.length === 0) {
      if (emptyMessage) emptyMessage.style.display = 'block';
      return;
    }

    if (emptyMessage) emptyMessage.style.display = 'none';

    wishListItems.forEach((product) => {
      const productURL = product.handle ? `/products/${product.handle}` : '#';
      const image = product.image || '';

      const itemHTML = `
        <div class="wishlist-item" data-id="${product.id}">
          <a href="${productURL}" class="wishlist-item__image">
            ${image ? `<img src="${image}" alt="${product.productName}">` : ''}
          </a>

          <div class="wishlist-item__info">
            <a href="${productURL}">
              <p class="wishlist-item__title">${product.productName}</p>
            </a>

            <p class="wishlist-item__price">${product.price}</p>
          </div>

            <button
        type="button"
        class="remove-wishlist"
        data-id="${product.id}"
        title="Remove from Wishlist"
        aria-label="Remove from Wishlist"
        >
        <svg viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18" stroke-width="2" stroke-linecap="round"/>
            <path d="M6 6L18 18" stroke-width="2" stroke-linecap="round"/>
        </svg>
        </button>
        </div>
      `;

      wishlistContainer.insertAdjacentHTML('beforeend', itemHTML);
    });
  };

  const storage = (id, product, node) => {
    if (!id || typeof product !== 'object') {
      console.error('Wishlist: Invalid product data or ID.', { id, product });
      return;
    }

    let eventType = 'wished';

    if (id in wishes) {
      eventType = 'unwish';
      delete wishes[id];
      showToast(`${product.productName} removed from Wishlist`, 'info');
    } else {
      wishes[id] = product;
      showToast(`${product.productName} added to Wishlist!`, 'success');
    }

    try {
      localStorage.setItem('wishes', JSON.stringify(wishes));
    } catch (error) {
      console.error('Wishlist: Error updating localStorage:', error);
    }

    updateButtonState(id, node);
    updateWishlistCount();
    renderWishlistPage();

    on[eventType].forEach((cb) => cb({ id, node, product }));
  };

  const init = () => {
    updateAllButtons();
    updateWishlistCount();
    renderWishlistPage();
  };

  document.body.addEventListener('click', function (event) {
    const wishButton = event.target.closest('.wish-button');
    const removeButton = event.target.closest('.remove-wishlist');

    if (wishButton) {
      event.preventDefault();

      const productData = getProductDataFromNode(wishButton);
      storage(productData.id, productData, wishButton);
    }

    if (removeButton) {
      event.preventDefault();

      const id = removeButton.dataset.id;
      const product = wishes[id];

      if (product) {
        storage(id, product, removeButton);
      }
    }
  });

  init();

  document.addEventListener('shopify:section:load', init);

  return {
    get count() {
      return am;
    },
    on: (eventName, cb) => {
      if (on[eventName]) on[eventName].push(cb);
    },
    wishes,
    update: updateButtonState,
    storage,
    renderWishlistPage,
    init
  };
})(localStorage.getItem('wishes'));